/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningssortsold2Inputs */

const en_earningssortsold2 = /** @type {(inputs: Earningssortsold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold`)
};

const de_earningssortsold2 = /** @type {(inputs: Earningssortsold2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkauft`)
};

/**
* | output |
* | --- |
* | "Sold" |
*
* @param {Earningssortsold2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningssortsold2 = /** @type {((inputs?: Earningssortsold2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningssortsold2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningssortsold2(inputs)
	return de_earningssortsold2(inputs)
});
export { earningssortsold2 as "earningsSortSold" }